// extracted by mini-css-extract-plugin
module.exports = {"okay":"eachavatar_okay__2bhXl","upperball":"eachavatar_upperball__3po6q","upperballone":"eachavatar_upperballone__1iLks"};